import { useCallback } from 'react';

import { TranscriptionQuotaQuery, TranscriptionQuotaResult } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { performCqrsQueryGet } from '@dreryk/command-query-react-common';

import { resolveAiAssistantTokensQuotaLevel } from './aiAssistantTokensQuota.utils';
import { dispatchAiAssistantTokensQuotaSnackbarEvent } from './dispatchAiAssistantTokensQuotaSnackbarEvent';

type VerifyAiAssistantTokensQuota = () => Promise<boolean>;

export const useAiAssistantTokensQuotaGuard = (): VerifyAiAssistantTokensQuota => {
   return useCallback(async () => {
      const quota = await performCqrsQueryGet<TranscriptionQuotaResult>(() => new TranscriptionQuotaQuery(), {
         staleTime: 0,
      });
      const level = resolveAiAssistantTokensQuotaLevel(quota);

      dispatchAiAssistantTokensQuotaSnackbarEvent(level);

      return level !== 'EXHAUSTED';
   }, []);
};
